import React from 'react';
import { Button } from 'antd';
import env from '../../environment';

export const MIGRATION_BANNER_HEIGHT = 72;

const PERSEFONE_URL_BY_ENV = {
	prod: 'https://persefone.gibobs.gibobs.one',
	staging: 'https://staging.persefone.gibobs.gibobs.one'
};

const getPersefoneUrl = () =>
	PERSEFONE_URL_BY_ENV[env.env] || 'https://dev.persefone.gibobs.gibobs.one';

function MigrationBanner() {
	return (
		<div
			style={{
				minHeight: MIGRATION_BANNER_HEIGHT,
				background: '#FFF7E6',
				borderBottom: '1px solid #FFD591',
				display: 'flex',
				flexWrap: 'wrap',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 16,
				padding: '6px 24px',
				boxSizing: 'border-box'
			}}
		>
			<div style={{ overflow: 'hidden' }}>
				<div style={{ fontWeight: 600, fontSize: 13, color: '#874D00', lineHeight: '18px' }}>
					⚠️ ATENCIÓN: Al usar Hadmin puedes experimentar problemas o comportamientos inesperados
				</div>
				<div style={{ fontSize: 12, color: '#874D00', lineHeight: '16px' }}>
					Esta plataforma ya no recibe mantenimiento ni actualizaciones. Para trabajar de manera
					segura y actualizada, debes migrar a Perséfone.
				</div>
			</div>
			<Button
				type="primary"
				href={getPersefoneUrl()}
				target="_blank"
				rel="noopener noreferrer"
				style={{ flexShrink: 0 }}
			>
				Ir a Perséfone ahora ➔
			</Button>
		</div>
	);
}

export default MigrationBanner;
